import React from 'react'

import Modalizer from 'components/modalizer/modalizer'
import SecondaryTitle from 'components/title_secondary/title_secondary'
import { MainButton, CancelButton } from 'components/button'
import TextInput from 'components/dpc_input/text/text_input'
import CSSModules from 'react-css-modules'

import styles from './input_prompt.scss'

const InputPrompt = props => (
	<Modalizer modalName={props.modalName} width='336px' closeAction={() => props.closeAction(props.modalName)}>
		<div>
			<div>
				<SecondaryTitle icon={props.titleIcon}>{props.titleText}</SecondaryTitle>
			</div>
			<div styleName="input">
				<TextInput
					placeholder={props.placeholder}
					message={props.message}
					status={props.status}
					value={props.value}
					autoFocus={props.autoFocus}
					onEnterKey={props.onEnterKeyHandler}
					onChange={props.onChangeHandler}
					tabIndex={100} />
			</div>
			<div styleName="buttons">
				<div styleName="buttons_item">
					<CancelButton
						tabIndex={101}
						focus={true}
						onClick={props.cancelButtonClickHandler}>
						{props.cancelButtonText}
					</CancelButton>
				</div>
				<div styleName="buttons_item">
					<MainButton
						tabIndex={102}
						focus={true}
						disabled={props.mainButtonDisabled}
						onClick={props.mainButtonClickHandler}>
						{props.mainButtonText}
					</MainButton>
				</div>
			</div>
		</div>
	</Modalizer>
)

export default CSSModules(InputPrompt, styles, {allowMultiple: true})
